'use strict';

import React, { Component } from 'react'

let app = window.app;

export default class Image extends Component
{
	state = { id: ++app.images_id };

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		window.objectFitImages(document.getElementById(state.id));
	}

	componentDidUpdate ()
	{
		const component = this, props = this.props, state = this.state;

		window.objectFitImages(document.getElementById(state.id));
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const src = document.location.hostname === 'localhost'
		? 'https://appli.synergies.site' + props.src
		: props.src;

		const output =
		(
			<img className={ props.className || 'u-responsive-img' }
				src={ src } alt={ props.alt } title={ props.title }
				id={ 'img-' + state.id }
			/>
		);

		return output;
	}
}
